module.exports = __webpack_public_path__ + "static/media/datapicker.2fab3e19.gif";